var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.supergroups.length > 0
    ? _c("nav", { attrs: { "aria-label": "breadcrumb" } }, [
        _c(
          "ol",
          { staticClass: "breadcrumb bg-light p-2 rounded" },
          _vm._l(_vm.supergroups, function(supergroup, index) {
            return _c(
              "li",
              {
                key: supergroup.uuid,
                staticClass: "breadcrumb-item",
                class: { active: index === _vm.supergroups.length - 1 }
              },
              [
                index < _vm.supergroups.length - 1
                  ? _c(
                      "a",
                      { attrs: { href: _vm.supergroupLink(supergroup.uuid) } },
                      [_vm._v(_vm._s(supergroup.name))]
                    )
                  : _c(
                      "a",
                      {
                        attrs: {
                          "aria-current": "page",
                          href: _vm.supergroupLink(supergroup.uuid)
                        }
                      },
                      [_vm._v(_vm._s(supergroup.name))]
                    )
              ]
            )
          }),
          0
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }